module.exports = __webpack_public_path__ + "static/img/u5.64439f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u5.png
// module id = 0Yny
// module chunks = 0